import React, {Fragment, useEffect, useRef, useState} from "react";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from 'react-router';
import Loader from "../../components/Loader/Loader";
import deployAlertsLottie from '../../assets/images/deploy_alerts_lottie.json';
import savingDefaultsLottie from '../../assets/images/saving_defaults_lottie.json';
import {
  getAzureAlerts as onGetAzureAlerts,
  getAzureResourceByResourceID,
  getDefaultAzureThresholdByMonitoredResourceID,
  getAzureThreshold as onGetAzureThreshold,
  getServices as onGetServices,
  getMissingAzureAlertsByResourceID as onGetMissingAzureAlertsByResourceID,
  postDisableAzureAlerts as onPostDisableAzureAlerts,
  postEnableAzureAlerts as onPostEnableAzureAlerts,
  putAzureAlerts as onPutAzureAlerts,
  postSpecificAzureResourceServiceMapping as onPostSpecificAzureServiceMapping,
  postSpecificAzureCreateResourceAlerts as onPostSpecificAzureCreateResourceAlerts,
  getNotificationChannel as onGetNotificationChannel,
  getPagerDutyServices as onGetPagerDutyServices,
  getOpsGenieTeams as onGetOpsGenieTeams,
  postAzureResourcePagerdutyServiceMapping as onPostResourcePagerdutyServiceMapping,
  postAzureResourceOpsGenieTeamMapping as onPostResourceOpsGenieTeamMapping,
  getAzureDynamicAlerts as onGetAzureDynamicAlerts,
  getMissingAzureDynamicAlertsByResourceID as onGetMissingAzureDynamicAlertsByResourceID,
  postSpecificAzureCreateResourceAlertsDynamic,
} from "../../store/actions";
import {
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  CardTitle,
  CardBody,
  Col,
  Modal,
  ModalHeader,
  Row,
  Table, UncontrolledAccordion, Tooltip, TabPane, TabContent, Nav, NavItem, NavLink, Popover, PopoverBody
} from "reactstrap";
import Card from "components/PurpleTheme/Card";
import Switch from "react-switch";
import { Link } from 'react-router-dom';
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Select from 'react-select';
import {
  getStateSpecificAzureLogo as getAzureLogo,
} from "../../helpers/component_helpers";
import connectTeamLottie from '../../assets/images/connect_team_lottie.json';
import "./azure_alert.scss";
import classnames from "classnames";


const AzureAlert = () => {
  document.title = "AzureAlert | Temperstack";
  const headers = ['Aggregation','Metric Name', 'Operator', 'Value', 'Unit', 'Window Size','Evaluation Period', 'Actions']

  const DynamicHeaders = ['Aggregation','Metric Name', 'Operator', 'Alert Sensivity', 'Unit', 'Min failing Periods To Alert', 'No of Evaluation Periods', 'Actions']

  let environments = [
    { value: 'PRODUCTION', label: 'PRODUCTION' },
    { value: 'UAT', label: 'UAT' },
    { value: 'STAGING', label: 'STAGING' },
    { value: 'PREPROD', label: 'PREPROD' },
    { value: 'DEV', label: 'DEV' },
    { value: 'OTHER', label: 'OTHER' },
  ]
  const params = useParams()
  const dispatch = useDispatch();
  const [deployModal, setDeployModal] = useState(false);
  const [changedValues, setchangedValues] = useState({});
  const [changedValuesDynamic, setchangedValuesDynamic] = useState({});
  const [mapServiceModal, setMapServiceModal] = useState(false);
  const [serviceOptions, setServiceOptions] = useState([]);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedEnvironment, setSelectedEnvironment] = useState(null);
  const [isLoading1, setIsLoading1] = useState(false);
  const [azureDeployModal, setAzureDeployModal] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [ttop, settop] = useState(false);
  const [dttop, setdtop] = useState(false);
  const [tright, settright] = useState(false);
  const [finalServices, setFinalServices] = useState({})
  const [opsgenieTeams, setOpsgenieTeams] = useState([]);
  const [pagerdutyServices, setPagerdutyServices] = useState([]);
  const [services, setServices] = useState([]);
  const [primaryChannel, setPrimaryChannel] = useState(null);
  const [btnHover, setBtnHover] = useState(false);
  const [popoverOpenAlertName, setPopoverOpenAlertName] = useState({});

  const handleMouseOverAlertName = (alertId) => {
    setPopoverOpenAlertName(prevState => ({
      ...prevState,
      [alertId]: true
    }));
  };

  const handleMouseLeaveAlertName = (alertId) => {
    setPopoverOpenAlertName(prevState => ({
      ...prevState,
      [alertId]: false
    }));
  };

  const startLoading1 = () => {
    setIsLoading1(true);
    setTimeout(() => {
      setIsLoading1(false);
    }, 4000);
  };

  const startLoading2 = () => {
    setIsLoading2(true);
    setTimeout(() => {
      setIsLoading2(false);
    }, 4000);
  };

  useEffect(() => {
    dispatch(onGetAzureAlerts(params.resourceId))
    dispatch(onGetAzureDynamicAlerts(params.resourceId))
  }, [onGetAzureAlerts, onGetAzureDynamicAlerts]);

  useEffect(() => {
    dispatch(onGetServices());
  }, [onGetServices]);

  useEffect(() => {
    dispatch(onGetNotificationChannel());
  }, [onGetNotificationChannel]);

  useEffect(() => {
    dispatch(onGetPagerDutyServices());
  }, [onGetPagerDutyServices]);

  useEffect(() => {
    dispatch(onGetOpsGenieTeams());
  }, [onGetOpsGenieTeams]);

  const { notification_channel } = useSelector(state => ({
    notification_channel: state.Service.notification_channel
  }));

  const reduxPagerdutyServices = useSelector(state =>
    state.Service.pagerduty_services
  );

  const reduxOpsgenieTeams = useSelector(state =>
    state.OpsGenieTeams.opsgenie_teams
  );

  const reduxServices = useSelector(state =>
    state.Service.services
  );

  const { azure_resource } = useSelector(state => ({
    azure_resource: state.AzureAlerts.azure_resource || {},
  }));

  const { thresholds } = useSelector(state => ({
    thresholds: state.AzureThresholds.azure_threshold || []
  }));


  useEffect(() => {
    setOpsgenieTeams(reduxOpsgenieTeams);
  }, [reduxOpsgenieTeams]);

  useEffect(() => {
    setPagerdutyServices(reduxPagerdutyServices);
  }, [reduxPagerdutyServices]);

  useEffect(() => {
    setServices(reduxServices);
  }, [reduxServices]);

  useEffect(() => {
    const primaryChannel = notification_channel?.find(channel => channel.is_primary);
    setPrimaryChannel(primaryChannel)
  }, [notification_channel])

  useEffect(() => {
    if (azure_resource?.environment) {
      setSelectedEnvironment(azure_resource?.environment);
    }
    else setSelectedEnvironment(null);
  }, [azure_resource?.environment]);
  useEffect(() => {

    const matchingServices = services?.find(service => service?.id === azure_resource?.application_service_id);
    const matchingPagerDutyService = pagerdutyServices?.find(service => service?.id === azure_resource?.pagerduty_service_id);
    const matchingOpsgenieServices = opsgenieTeams?.find(service => service?.id === azure_resource?.opsgenie_team_id);
    const matchingNotificationChannel = notification_channel?.find(channel => channel?.is_primary === true);

    if (matchingNotificationChannel) {
      if (matchingNotificationChannel.name == "Email") {
        setFinalServices(matchingServices)
      }
      else if (matchingNotificationChannel.name == "PagerDuty") {
        setFinalServices(matchingPagerDutyService)
      }
      else if (matchingNotificationChannel.name == "OpsGenie") {
        setFinalServices(matchingOpsgenieServices)
      }
      else {
        setFinalServices({})
      }
    }
  }, [services, pagerdutyServices, opsgenieTeams, notification_channel, azure_resource]);

  useEffect(() => {
    const matchingNotificationChannel = notification_channel?.find(channel => channel?.is_primary === true);

    if (matchingNotificationChannel) {
      if (matchingNotificationChannel.name == "Email") {
        const options = services?.map((service) => ({
          value: service.id,
          label: service.name
        }));
        setServiceOptions(options);
        const initialSelectedService = services?.find(service => service.id === azure_resource?.application_service_id);
        setSelectedService(initialSelectedService?.name);
      } else if (matchingNotificationChannel.name == "PagerDuty") {
        const options = pagerdutyServices?.map((service) => ({
          value: service.id,
          label: service.name
        }));
        setServiceOptions(options);
        const initialSelectedService = pagerdutyServices?.find(service => service.id === azure_resource?.pagerduty_service_id);
        setSelectedService(initialSelectedService?.name);
      } else if (matchingNotificationChannel.name == "OpsGenie") {
        const options = opsgenieTeams?.map((service) => ({
          value: service.id,
          label: service.name
        }));
        setServiceOptions(options);
        const initialSelectedService = opsgenieTeams?.find(service => service?.id === azure_resource?.opsgenie_team_id);
        setSelectedService(initialSelectedService?.name);
      }
    }

  }, [services, pagerdutyServices, opsgenieTeams, notification_channel, azure_resource]);
  useEffect(() => {
    dispatch(getAzureResourceByResourceID(params.resourceId));
  }, [getAzureResourceByResourceID]);

  useEffect(() => {
    dispatch(getDefaultAzureThresholdByMonitoredResourceID(params.resourceId));
  }, [getDefaultAzureThresholdByMonitoredResourceID]);

  useEffect(() => {
    dispatch(onGetMissingAzureAlertsByResourceID(params.resourceId))
    dispatch(onGetMissingAzureDynamicAlertsByResourceID(params.resourceId));
  }, [onGetMissingAzureAlertsByResourceID, onGetMissingAzureDynamicAlertsByResourceID]);

  useEffect(() => {
    dispatch(onGetAzureThreshold());
  }, [onGetAzureThreshold]);


  useEffect(() => {
    if (thresholds.length > 0) {
      var metricThresholds = {}
      thresholds.map((threshold, index) => {
        if (metricThresholds[threshold.metric_id] === undefined) {
          metricThresholds[threshold.metric_id] = {}
        }
        metricThresholds[threshold.metric_id] = threshold
      })
      setMetricThresholdsList(metricThresholds)
    }
  }, [thresholds]);

  const { alerts } = useSelector(state => ({
    alerts: state.AzureAlerts.azure_alerts[params.resourceId] || [],
  }));

  const { dynamic_alerts } = useSelector(state => ({
    dynamic_alerts: state.AzureAlerts.azure_dynamic_alerts || [],
  }));

  const { dynamic_alerts_deployment } = useSelector(state => ({
    dynamic_alerts_deployment: state.AzureAlerts.dynamic_alert_deployment || [],
  }));
  const { azure_resource_missing_alerts } = useSelector(state => ({
    azure_resource_missing_alerts: state.AzureAlerts.azure_resource_missing_alerts || [],
  }));

  const { azure_missing_dynamic_alerts } = useSelector(state => ({
    azure_missing_dynamic_alerts: state.AzureAlerts.azure_resource_missing_dynamic_alerts || [],
  }));

  const { default_threshold_azure_resource } = useSelector(state => ({
    default_threshold_azure_resource: state.AzureAlerts.default_threshold_azure_resource || [],
  }));
  const getMatchingData = () => {
    const finalArray = [];
    if (Array.isArray(azure_resource_missing_alerts) && Array.isArray(default_threshold_azure_resource) && default_threshold_azure_resource?.length > 0 && azure_resource_missing_alerts?.length > 0) {
      azure_resource_missing_alerts?.forEach(resourceAlert => {
        const matchingThreshold = default_threshold_azure_resource?.find(
          threshold => threshold?.azure_metric_id === resourceAlert?.azure_metric_id
        );

        if (matchingThreshold) {
          finalArray.push({ matchingThreshold });
        }

      });
    }

    return finalArray;

  }
  const finalArray = getMatchingData();

  const [metricThresholdsList, setMetricThresholdsList] = useState({});

  const changeHeaders = ['Key', 'Old Value', 'New Value']

  const ThresholdCondition = ['LessThanOrEqual', 'GreaterThanOrEqual', 'GreaterThan', 'LessThan']
  const ThresholdConditionDisplay = {
    'LessThanOrEqual': '<=',
    'GreaterThanOrEqual': '>=',
    'GreaterThan': '>',
    'LessThan': '<'
  };
  const WindowSizeValues = ['1 Minute' ,"5 Minutes","15 Minutes","30 Minutes","60 Minutes",'6 Hours','12 Hours','24 Hours']

  const EvaluationFrequencyValues = ["1 Minute" ,"5 Minutes","15 Minutes","30 Minutes","60 Minutes"]

  const NumberOfEvaluationPeriods = [1.0,2.0,3.0,4.0,5.0,6.0]

  const MinFailingPeriodsToAlert = [1.0,2.0,3.0,4.0,5.0,6.0]

  const AlertSensivity = ["High","Medium","Low"]

  const DynamicThresholdCondition = ['GreaterOrLessThan', 'GreaterThan', 'LessThan']

  const minutesConversion = (value) => {
    if (typeof value === 'string') {
      return value;
    } else if (typeof value === 'number') {
      switch (true) {
        case value === 1:
            return "1 Minute";
        case value === 5:
          return "5 Minutes";
        case value === 15:
          return "15 Minutes";
        case value === 30:
          return "30 Minutes";
        case value === 60:
          return "60 Minutes";
        case value === 360:
          return "6 Hours";
        case value === 720:
          return "12 Hours";
        case value === 1440:
          return "24 Hours";
        default:
          return `${value} Minutes`;
      }
    }
    return value;
  };

  const handleFormChange = (index, event) => {
    const values = [...alerts];
    var changed_values = { ...changedValues };
    var title = values[index]['metric']['name'];
    let windowSize;
    let evaluation;
    const windowSizeValue = event.target.name === 'window_size' ? event.target.value : values[index]['window_size'];
    if (typeof windowSizeValue === 'string') {
      if (windowSizeValue.includes('Hours')) {
        const intValue = parseFloat(windowSizeValue.split(' ')[0]);
        windowSize = intValue * 60;
      } else {
        windowSize = parseFloat(windowSizeValue.split(' ')[0]);
      }
    } else {
      windowSize = parseFloat(windowSizeValue);
    }
    const evaluationValue = event.target.name === 'evaluation' ? event.target.value : values[index]['evaluation'];
    if (typeof evaluationValue === 'string') {
      if (evaluationValue.includes('Hours')) {
        const intValue = parseFloat(evaluationValue.split(' ')[0]);
        evaluation = intValue * 60;
      } else {
        evaluation = parseFloat(evaluationValue.split(' ')[0]);
      }
    } else {
      evaluation = parseFloat(evaluationValue);
    }
    if (!isNaN(windowSize) && !isNaN(evaluation)) {
      if (windowSize < evaluation) {
        setPeriodError('Window size must be equal to or greater than evaluation frequency.');
      } else if (evaluation > windowSize) {
        setPeriodError('Evaluation frequency must be equal to or less than window size.');
      } else {
        setPeriodError('');
      }
    }

    if (changed_values[title] === undefined) {
      changed_values[title] = {};
    }

    if (changed_values[title][event.target.name] === undefined) {
      changed_values[title][event.target.name] = {
        'id': values[index]['id'],
        'title': values[index]['metric']['name'],
        'name': event.target.name,
        'old': values[index][event.target.name],
        'new': event.target.value
      };
    } else {
      const oldValue = parseFloat(changed_values[title][event.target.name]['old']);
      const newValue = parseFloat(event.target.value);

      if (oldValue === newValue) {
        delete changed_values[title][event.target.name];

        if (Object.keys(changed_values[title]).length === 0) {
          delete changed_values[title];
        }
      } else {
        changed_values[title][event.target.name]['new'] = event.target.value;
      }
    }

    setchangedValues(changed_values);
    values[index][event.target.name] = event.target.value;
  };


  const handleFormChangeDynamic = (index, event) => {
    const values = [...dynamic_alerts];
    var changed_values_dynamic = { ...changedValuesDynamic };
    var title = values[index]['metric']['name'];
    const number_of_evaluation_periods_values = event.target.name === 'number_of_evaluation_periods' ? event.target.value : values[index]['number_of_evaluation_periods'];
    const min_failing_periods_to_alert_values = event.target.name === 'min_failing_periods_to_alert' ? event.target.value : values[index]['min_failing_periods_to_alert'];
    if (!isNaN(number_of_evaluation_periods_values) && !isNaN(min_failing_periods_to_alert_values)) {
      if (number_of_evaluation_periods_values < min_failing_periods_to_alert_values) {
        setValueError('Number of Evaluation Periods must be equal to or greater than Min failing Periods to Alert.');
      } else if (min_failing_periods_to_alert_values > number_of_evaluation_periods_values) {
        setValueError('Min failing Periods to Alert must be equal to or less than Number of Evaluation Periods.');
      } else {
        setValueError('');
      }
    }

    if (changed_values_dynamic[title] === undefined) {
      changed_values_dynamic[title] = {};
    }

    if (changed_values_dynamic[title][event.target.name] === undefined) {
      changed_values_dynamic[title][event.target.name] = {
        'id': values[index]['id'],
        'title': values[index]['metric']['name'],
        'name': event.target.name,
        'old': values[index][event.target.name],
        'new': event.target.value
      };
    } else {
      const oldValue = parseFloat(changed_values_dynamic[title][event.target.name]['old']);
      const newValue = parseFloat(event.target.value);

      if (oldValue === newValue) {
        delete changed_values_dynamic[title][event.target.name];

        if (Object.keys(changed_values_dynamic[title]).length === 0) {
          delete changed_values_dynamic[title];
        }
      } else {
        changed_values_dynamic[title][event.target.name]['new'] = event.target.value;
      }
    }

    setchangedValuesDynamic(changed_values_dynamic);
    values[index][event.target.name] = event.target.value;
  };

  const [periodError, setPeriodError] = useState('');

  const [valueError,  setValueError] = useState('');


  const handleSave = () => {
    setDeployModal(true);
  };

  const handleSubmit = () => {
    var alerts_update = [];

    Object.values(changedValues).forEach((changedValue) => {
      var payload = {};

      Object.entries(changedValue).forEach(([key, value]) => {
        payload['alert_id'] = value.id;
        payload[value.name] = value.new;
      });

      alerts_update.push(payload);
    });

    Object.values(changedValuesDynamic).forEach((changedValuesDynamic) => {
      var payload = {};

      Object.entries(changedValuesDynamic).forEach(([key, value]) => {
        payload['alert_id'] = value.id;
        payload[value.name] =  value.new;
      });
      alerts_update.push(payload);
    });

    dispatch(onPutAzureAlerts(alerts_update));

    setDeployModal(false);
  };


  const handleDisable = (alert_id) => {
    const payload = {
      'alert_id': alert_id,
      'enable': false
    }

    dispatch(onPostDisableAzureAlerts(payload));
  };

  const handleEnable = (alert_id) => {
    const payload = {
      'alert_id': alert_id,
      'enable': true
    }
    dispatch(onPostEnableAzureAlerts(payload));
  };

  const handleDeployIndividualAlert = (monitored_resource_id, metric_id) => {

    const payload = {
      'metric_id': metric_id,
      'azure_monitored_resource_ids': [monitored_resource_id],
    }

    dispatch(onPostSpecificAzureCreateResourceAlerts(payload));

  };

  const handleDeployIndividualDynamicAlert = (monitored_resource_id, threshold_id) => {

    const payload = {
      'threshold_id': threshold_id,
      'azure_monitored_resource_ids': [monitored_resource_id],
    }

    dispatch(postSpecificAzureCreateResourceAlertsDynamic(payload));

  };

  const [isLoading_DisableAlert, setisLoading_DisableAlert] = useState(false);

  const startLoading_DisableAlert = () => {
    setisLoading_DisableAlert(true);

    // Simulate loading process
    setTimeout(() => {
      setisLoading_DisableAlert(false);
    }, 4000);
  };

  const [isLoading_EnableAlert, setisLoading_EnableAlert] = useState(false);

  const startLoading_EnableAlert = () => {
    setisLoading_EnableAlert(true);

    // Simulate loading process
    setTimeout(() => {
      setisLoading_EnableAlert(false);
    }, 4000);
  };

  const [isLoading_SaveAlert, setisLoading_SaveAlert] = useState(false);

  const startLoading_SaveAlert = () => {
    setisLoading_SaveAlert(true);

    // Simulate loading process
    setTimeout(() => {
      setisLoading_SaveAlert(false);
    }, 4000);
  };

  const handleMapApplicationService = () => {
    setMapServiceModal(true);
  }

  const cancelMapServiceModal = () => {
    setMapServiceModal(false);
  }

  const handleServiceFormChange = (selectedOption) => {
    setSelectedService(selectedOption);
  };

  const handleEnvironmentChange = (selectedOption) => {
    setSelectedEnvironment(selectedOption);
  }

  const handleServiceMapping = async () => {
    const matchingNotificationChannel = notification_channel?.find(channel => channel?.is_primary === true);
    if (matchingNotificationChannel?.name === 'Email') {
      let payload = {
        'azure_monitored_resource_ids': [params.resourceId],
        'application_service_id': selectedService?.value || serviceOptions?.find(option => option.label === selectedService)?.value || '',
        'environment': selectedEnvironment?.value || 'PRODUCTION',
      };
      await dispatch(onPostSpecificAzureServiceMapping(payload));
      setMapServiceModal(false);
    } else if (matchingNotificationChannel?.name === 'PagerDuty') {
      let payload = {
        'azure_monitored_resource_ids': [params.resourceId],
        'pagerduty_service_id': selectedService?.value || serviceOptions?.find(option => option.label === selectedService)?.value || '',
        'environment': selectedEnvironment?.value || 'PRODUCTION',
      };
      await dispatch(onPostResourcePagerdutyServiceMapping(payload));
      setMapServiceModal(false);
    } else if (matchingNotificationChannel?.name === 'OpsGenie') {
      let payload = {
        'azure_monitored_resource_ids': [params.resourceId],
        'opsgenie_team_id': selectedService?.value || serviceOptions?.find(option => option.label === selectedService)?.value || '',
        'environment': selectedEnvironment?.value || 'PRODUCTION',
      };
      await dispatch(onPostResourceOpsGenieTeamMapping(payload));
      setMapServiceModal(false);
    }
  }

  const customOptionRenderer = (option) => {
    if (option.value === "/add-service") {
      return (
        <div 
          className="d-flex justify-content-center align-items-center gap-2 btn btn-soft-primary"
          onMouseEnter={() => setBtnHover(true)}
          onMouseLeave={() => setBtnHover(false)}
          style={{cursor:"pointer"}}>
          <i className={`fas fa-plus font-size-14 ${btnHover ? 'text-white' : 'text-primary'}`} />
          <span>
            {option.label}
          </span>
        </div>
      );
    } else {
      return option.label;
    }
  };

  const [defaultOpen, setDefaultOpen] = useState(alerts?.length === 0 ? '2' : '1');
  const [accordionKey, setAccordionKey] = useState(0);

  useEffect(() => {
    setDefaultOpen(alerts?.length === 0 ? '2' : '1');
    setAccordionKey(prevKey => prevKey + 1); //defaultAlert in accordion does not create a re-render of the accordion component so using an accordion key to force a re-render so that the correct accordion opens
  }, [alerts]);

  const handleDefaultDeploy = () => {
    setAzureDeployModal(true);
  }

  const cancelDeployModal = () => {
    setAzureDeployModal(false);
  }

  const handleDeploy = () => {
    if (azure_resource?.application_service_email_id !== null || azure_resource?.opsgenie_team_id !== null || azure_resource?.pagerduty_service_id !== null) {
      let resourceId = azure_resource?.id;
      let payload = {
        'azure_monitored_resource_ids': [resourceId],
      }
      dispatch(onPostSpecificAzureCreateResourceAlerts(payload));
    }
    setAzureDeployModal(false);
  }

  const OffSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 1
        }}
      >
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 1
        }}
      >
      </div>
    );
  };

  const [toggles, setToggles] = useState({});

  const [dynamictoggles, setDynamicToggles] = useState({});

  useEffect(() => {
    const initialToggles = {};
    alerts.forEach(alert => {
      initialToggles[alert.id] = alert.enabled;
    });
    setToggles(initialToggles);
  }, [alerts]);

  const toggleAlertDynamic = (index, alertId) => {
    const updatedToggles = { ...dynamictoggles };
    updatedToggles[alertId] = !updatedToggles[alertId];
    setDynamicToggles(updatedToggles);

    if (!updatedToggles[alertId]) {
      startLoading_DisableAlert();
      handleDisable(alertId);
    } else {
      startLoading_EnableAlert();
      handleEnable(alertId);
    }
  };

  useEffect(() => {
    const initialToggles = {};
    dynamic_alerts.forEach(alert => {
      initialToggles[alert.id] = alert.enabled;
    });
    setDynamicToggles(initialToggles);
  }, [dynamic_alerts, dynamic_alerts_deployment]);

  const toggleAlert = (index, alertId) => {
    const updatedToggles = { ...toggles };
    updatedToggles[alertId] = !updatedToggles[alertId];
    setToggles(updatedToggles);

    if (!updatedToggles[alertId]) {
      startLoading_DisableAlert();
      handleDisable(alertId);
    } else {
      startLoading_EnableAlert();
      handleEnable(alertId);
    }
  };

  const [tanomaly, settanomaly] = useState(false);
  const [activeTab, setactiveTab] = useState("1");

  const [tooltipstatic, setTooltipstatic] = useState({});

  const [tooltipdynamic, setTooltipdynamic] = useState({});

  useEffect(() => {
    const initialTooltipDynamic = {};
    azure_missing_dynamic_alerts?.forEach(alert => {
      initialTooltipDynamic[alert.id] = false;
    });
    setTooltipdynamic(initialTooltipDynamic);
  }, [azure_missing_dynamic_alerts]);


  useEffect(() => {
    const initialTooltipStatic = {};
    finalArray?.forEach(alert => {
      initialTooltipStatic[alert?.matchingThreshold?.azure_metric_id] = false;
    });
    setTooltipstatic(initialTooltipStatic);
  }, [azure_resource_missing_alerts]);

  const showTooltipDynamic = (alertId) => {
    setTooltipdynamic({
      ...tooltipdynamic,
      [alertId]: true,
    });
  };

  const hideTooltipDynamic = (alertId) => {
    setTooltipdynamic({
      ...tooltipdynamic,
      [alertId]: false,
    });
  };
const showTooltipStatic = (alertId) => {
  setTooltipstatic({
    ...tooltipstatic,
    [alertId]: true,
  })
}

const hideTooltipStatic = (alertId) => {
    setTooltipstatic({
        ...tooltipstatic,
        [alertId]: false,
    })
}
  const toggleTab = tab => {
    if (activeTab !== tab) {
      setactiveTab(tab);
    }
  };

  const customStyles = {
    zIndex: 9999,
    control: (provided, state) => ({
      ...provided,
      background: '#382b42', // Background color of the control (react-select)
      borderRadius: 0,
      color: "white",
      zIndex: 100,
      position:"relative",
      borderColor: state.isFocused ? 'rgb(white, 1)' : 'rgb(white, 0.7)', // Border color when focused
    }),
    option: (provided, state) => ({
      ...provided,
      position:"relative",
      zIndex: 100,
      backgroundColor: state.isSelected ? '#292036' : state.isFocused ? '#2d2941' : '#382b42',
      color: state.isSelected ? '#ffffff' : '#ffffff', // Text color of dropdown options
    }),
    menu: (provided) => ({
      ...provided,
      background: '#382b42',
      position: "absolute",
      zIndex: 200, // Background color of the dropdown menu

    }),
    singleValue: (provided) => ({
      ...provided,
      position:"relative",
      color: '#ffffff', // Color of the selected value
      zIndex: 100, 
    }),
  };

  const[popoverOpen1,setPopoverOpen1] = useState({});
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const handleMouseOverEndpoint = (key) => {
    toggleTooltip(key, true);
  };
  const handleMouseLeaveEndpoint = (key) => {
    toggleTooltip(key, false);
  };
  const toggleTooltip = (key, isOpen) => {
    setPopoverOpen1(prevState => ({
      ...prevState,
      [key]: isOpen,
    }));
  };

  const [currentIndex, setCurrentIndex] = useState(null);

  const toggle = (index) => {
    setTooltipOpen(!tooltipOpen);
    setCurrentIndex(index);
  };
  const newCurrentIndex = useRef(null);
  const handleMouseOver = (index) => {
    setCurrentIndex(index);
    newCurrentIndex.current = index;
    setTooltipOpen(true);
  };

  const handleMouseOut = () => {
    setTooltipOpen(false);
    newCurrentIndex.current = null;
    setCurrentIndex(null);
  };


  return (
    <React.Fragment>
      <Row>
        <Col lg="8">
          <Breadcrumbs title={"Azure Resource Alerts"} breadcrumbItem={"Azure Resource Alerts"} />
        </Col>
      </Row>
      <Row>
        <Col md={9}>
          <Card>
            <CardBody>
              <CardTitle className="mb-4 card-title">Resource Details</CardTitle>
              <div className="table-responsive">
                <table className="table-purple-org">
                  <tbody>
                  <tr>
                    <td scope="col">Resource Name:</td>
                    <td scope="col"><h6>{azure_resource?.name}</h6></td>
                  </tr>
                  <tr>
                    <td scope="col">Resource Type:</td>
                    <td scope="col">
                      <div className="resource-logo-display">
                        <img
                            src={getAzureLogo(azure_resource?.resource_name, azure_resource?.state)}
                            className="resource-logo"
                            alt="Resource Logo"
                        />
                        <h6 className="mt-2">{azure_resource?.resource_name}</h6>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td scope="col">Environment:</td>
                    <td scope="col"><h6>{azure_resource?.environment}</h6></td>
                  </tr>
                  <tr>
                    <td scope="col">Location:</td>
                    <td scope="col"><h6>{azure_resource?.location}</h6></td>
                  </tr>
                  <tr>
                    <td scope="col">Cloud ID:</td>
                    <td scope="col"><h6>{azure_resource?.cloud_reference_id}</h6></td>
                  </tr>
                  <tr>
                    {
                      (() => {
                        const primaryChannel = notification_channel?.find(channel => channel.is_primary);
                        if (primaryChannel?.name === 'Email') {
                          return (
                              <>
                                <td scope="col">Service:</td>
                                <td scope="col">
                                  <Link to={"/temperstack-notifications/" + azure_resource?.application_service_id}
                                        className="link-primary">
                                    {finalServices?.name}
                                  </Link>
                                </td>
                              </>
                          )
                        } else if (primaryChannel?.name === 'PagerDuty') {
                          return (
                              <>
                                <td scope="col">PagerDuty Service:</td>
                                <td scope="col">
                                  <Link to={"/pagerduty-services"} className="link-primary">
                                    {finalServices?.name}
                                  </Link>
                                </td>
                              </>
                          )
                        } else if (primaryChannel?.name === 'OpsGenie') {
                          return (
                              <>
                                <td scope="col">OpsGenie Team:</td>
                                <td scope="col">
                                  <Link to={"/opsgenie-teams"} className="link-primary">
                                    {finalServices?.name}
                                  </Link>
                                </td>
                              </>
                          )
                        }
                      })()
                    }
                  </tr>
                  <tr>
                    <td scope="col">Action:</td>
                    <td style={{display: 'flex', gap: '5px'}}>
                      <button className="btn btn-primary w-md" onClick={() => {
                        handleMapApplicationService();
                      }}>
                        Map {primaryChannel?.name === 'OpsGenie' ? 'Team' : 'Service'}
                      </button>
                      {azure_resource?.environment === 'PRODUCTION' &&
                          <button className={`btn btn-primary w-md ${finalServices?.name ? '' : 'disabled'}`}
                                  disabled={!finalServices?.name}
                                  onClick={() => {
                                    handleDefaultDeploy();
                                  }}
                          >
                            Deploy Alerts
                          </button>}
                      {(!finalServices?.name) && (
                          <>
                            <span
                                id="TooltipRight"
                                onMouseOver={() => settright(true)}
                                onMouseLeave={() => settright(false)}
                                className="alert-icon"
                                style={{
                                  marginLeft: '0px',
                                  alignSelf: 'center',
                                }}
                            >
                              <i className="mdi mdi-information-outline text-warning"/>
                            </span>
                            <Tooltip
                                placement="top"
                                isOpen={tright}
                                target="TooltipRight"
                                toggle={() => {
                                  settright(!tright);
                                }}
                                style={{
                                  border: "2px solid #f1b44c",
                                  borderRadius: "10px",
                                  backgroundColor: "#2a3042",
                                  zIndex: 1,
                                }}
                            >
                              Map resource to enable deployment
                            </Tooltip>
                          </>
                      )}

                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col md={7}>
        </Col>
        <Col md={5}>
          {
            (Object.entries(changedValues).length > 0) ?
              <button
                type="button"
                className="btn btn-primary bx-pull-right w-md"
                onClick={handleSave}
                disabled={periodError !== '' || !finalServices?.name}>
                Save and Deploy Alerts
              </button> : (Object.entries(changedValuesDynamic).length > 0) ?
                <button
                  type='button'
                  className="btn btn-primary bx-pull-right w-md"
                  onClick={handleSave}
                  disabled={valueError !== '' || !finalServices?.name}>
                  Save and Deploy Alerts
                </button> : null
          }
        </Col>
      </Row>
      <div>
        <Nav pills className="nav-custom">
          <NavItem className="nav-item-custom">
            <NavLink
                className={classnames({
                  active: activeTab === "1",
                })}
                onClick={() => {
                  toggleTab("1");
                }}
            >
              <span className="d-sm-block">Static Alerts</span>
            </NavLink>
          </NavItem>
          <NavItem className="nav-item-custom">
            <NavLink
                className={classnames({
                  active: activeTab === "2",
                })}
                onClick={() => {
                  toggleTab("2");
                }}
            >
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span className="d-sm-block" style={{ marginRight: '10px' }}>Anomaly Detection Alerts</span>
                <span
                    id="TooltipAnomaly"
                    onMouseOver={() => settanomaly(true)}
                    onMouseLeave={() => settanomaly(false)}
                    className="alert-icon"
                    style={{ marginRight: '10px' }}
                >
                  <i className="mdi mdi-information-outline text-warning" />
                </span>
                <Tooltip
                    placement="right"
                    isOpen={tanomaly}
                    target="TooltipAnomaly"
                    toggle={() => { settanomaly(!tanomaly); }}
                    style={{
                      border: "2px solid #f1b44c",
                      borderRadius: "10px",
                      backgroundColor: "#2a3042",
                      zIndex: 1
                    }}
                >
                  Anomaly Alerts are not considered in ALCOM score
                </Tooltip>
              </div>
            </NavLink>
          </NavItem>
        </Nav>

        <hr style={{ border: "1px solid #556ee6", backgroundColor: "#556ee6", width: "100%", marginTop: "-1px", }} />

        <TabContent activeTab={activeTab} className="py-4">
          <TabPane tabId="1">
            <div>
              <Row className="custom-resource-header">
                <Col lg={12}>
                  <UncontrolledAccordion key={accordionKey} defaultOpen={defaultOpen}>
                    <Fragment>
                      <AccordionItem style={{ borderBottom: "groove" }}>
                        <AccordionHeader targetId={"1"}>
                          <Row className="full-width">
                            <Col lg="6">
                              <h5 className="change-table-text">Alerts Deployed</h5>
                            </Col>
                          </Row>
                        </AccordionHeader>
                        <AccordionBody accordionId={"1"}>
                          <Row className="custom-resource-header mb-2">
                            <Col md="3">
                              <div className="mb-2 text-center">
                                Alert Name
                              </div>
                            </Col>
                            <Col md="1">
                              <div className="mb-2 text-center">
                                Aggregation
                              </div>
                            </Col>
                            <Col md="2">
                              <div className="mb-2 text-center">
                                Metric Name
                              </div>
                            </Col>
                            <Col md="1">
                              <div className="mb-2 text-center">
                                Operator
                              </div>
                            </Col>
                            <Col md="1">
                              <div className="mb-2 text-center">
                                Value
                              </div>
                            </Col>
                            <Col md="1">
                              <div className="mb-2 text-center">
                                Unit
                              </div>
                            </Col>
                            <Col md="1">
                              <div className="mb-2">
                                Window Size
                                {periodError && (
                                    <p className="invalid-error">{periodError}</p>
                                )}
                              </div>
                            </Col>
                            <Col md="1">
                              <div className="mb-2">
                                Evaluation Frequency
                                {periodError && (
                                    <p className="invalid-error">{periodError}</p>
                                )}
                              </div>
                            </Col>
                            <Col md="1">
                              <div className="mb-2">
                                Actions
                              </div>
                            </Col>
                          </Row>
                          {alerts?.length > 0 ? (
                                  alerts.map((alert, index) => {
                                    return (
                                        <div className="alerts-carditem" key={index} style={{ paddingBottom: '0.5rem' }}>
                                          <CardBody>
                                            <Row>
                                              <Col md="3" className="d-flex align-items-center justify-content-center">
                                                <div className="resource-name-truncate text-center"
                                                     id={`alert_name_tooltip_${alert?.id}`}
                                                     style={{
                                                       display: 'inline-flex',
                                                       maxWidth: 'min-content',
                                                       whiteSpace: 'nowrap',
                                                       overflow: 'hidden',
                                                       textOverflow: 'ellipsis',
                                                       fontSize: '14px',
                                                     }}
                                                     onMouseEnter={() => handleMouseOverAlertName(alert.id)}
                                                     onMouseLeave={() => handleMouseLeaveAlertName(alert.id)}
                                                >
                                                  <div style={{display: "inline-flex", alignItems: "center"}}>
                                                    {alert.name.length > 30 ? alert.name.substring(0, 30) + '...' : alert.name}
                                                  </div>
                                                  <Popover
                                                    placement="top"
                                                    isOpen={popoverOpenAlertName[alert.id] || false}
                                                    target={`alert_name_tooltip_${alert?.id}`}
                                                  >
                                                    <PopoverBody>{alert.name}</PopoverBody>
                                                  </Popover>
                                                </div>
                                              </Col>
                                              <Col md="1" className="d-flex align-items-center justify-content-center">
                                                <div className="text-center">
                                                  {alert.time_aggregation}
                                                </div>
                                              </Col>
                                              <Col md="2" className="d-flex align-items-center justify-content-center">
                                              <div className="d-flex align-items-center" style={{ gap: "1px" }}>
                                                <div className="resource-name-truncate text-center"
                                                     id={`resource_tooltip_${alert?.id}`}
                                                     style={{
                                                       display: 'inline-flex',
                                                       maxWidth: 'min-content',
                                                       whiteSpace: 'nowrap',
                                                       overflow: 'hidden',
                                                       textOverflow: 'ellipsis',
                                                       fontSize: '14px',
                                                     }}
                                                     onMouseEnter={() => handleMouseOverEndpoint(alert.id)}
                                                     onMouseLeave={() => handleMouseLeaveEndpoint(alert.id)}
                                                >
                                                  <div style={{display: "inline-flex", alignItems: "center"}}>
                                                    {alert.metric.name.length > 20 ? alert.metric.name.substring(0, 20) + '...' : alert.metric.name}
                                                  </div>
                                                  <Popover
                                                      placement="top"
                                                      isOpen={popoverOpen1[alert.id] || false}
                                                      target={`resource_tooltip_${alert?.id}`}
                                                  >
                                                    <PopoverBody>{alert.metric.name}</PopoverBody>
                                                  </Popover>
                                                </div>
                                                  <div className="d-flex align-items-center">
                                                    <p id={`TooltipExample_${index}`}
                                                       className="d-flex align-items-center m-0"
                                                       onMouseOver={() => handleMouseOver(index)}
                                                       onMouseLeave={() => handleMouseOut()}>
                                                      <i className="bx bx-info-circle font-size-18"/>
                                                    </p>
                                                    <Tooltip
                                                        placement="top"
                                                        isOpen={tooltipOpen && newCurrentIndex.current === index}
                                                        target={`TooltipExample_${index}`}
                                                        toggle={() => toggle(index)}
                                                        style={{
                                                          border: "2px solid #f1b44c",
                                                          borderRadius: "10px",
                                                          backgroundColor: "#2a3042",
                                                          zIndex: 1
                                                        }}
                                                    >
                                                      {alert?.metric?.description}
                                                    </Tooltip>
                                                  </div>
                                                </div>
                                              </Col>
                                              <Col md="1" className="d-flex align-items-center justify-content-center">
                                                <select
                                                    id="formrow-InputState"
                                                    name="operator"
                                                    className={"form-control text-center " + (changedValues[alert.metric.name] === undefined ? "" : (changedValues[alert.metric.name]['operator'] === undefined ? "" : " border-warning"))}
                                                    value={alert.operator}
                                                    style={{ width: '55px', height: '34px' }}
                                                    onChange={event => handleFormChange(index, event)}
                                                >
                                                  {ThresholdCondition.map((item, key) => (
                                                    <option key={key} value={item}>
                                                      {ThresholdConditionDisplay[item]}
                                                    </option>
                                                  ))}
                                                </select>
                                              </Col>
                                              <Col md="1" className="d-flex align-items-center justify-content-center">
                                                <input
                                                    type="number"
                                                    value={alert.threshold_value}
                                                    name="threshold_value"
                                                    className={"form-control text-center " + (changedValues[alert.metric.name] === undefined ? "" : (changedValues[alert.metric.name]['threshold_value'] === undefined ? "" : " border-warning"))}
                                                    id="autoSizingInputGroup"
                                                    style={{ width: '65px', height: '34px' }}
                                                    placeholder="Threshold Value"
                                                    onChange={event => handleFormChange(index, event)}
                                                />
                                              </Col>
                                              <Col md="1" className="d-flex align-items-center justify-content-center">
                                                <div className="text-center ms-2">
                                                  {alert.metric.unit}
                                                </div>
                                              </Col>
                                              <Col md="1" className="d-flex align-items-center justify-content-center">
                                                <select
                                                    value={minutesConversion(alert.window_size)}
                                                    className={"form-control text-center " + (changedValues[alert.metric.name] === undefined ? "" : (changedValues[alert.metric.name]['window_size'] === undefined ? "" : " border-warning"))}
                                                    name="window_size"
                                                    id="autoSizingInputGroup"
                                                    onChange={event => handleFormChange(index, event)}
                                                >
                                                  {WindowSizeValues.map((item, key) => (<option key={key} value={item}>{item}</option>))}
                                                </select>
                                              </Col>
                                              <Col md="1" className="d-flex align-items-center justify-content-center">
                                                <select
                                                    value={minutesConversion(alert.evaluation)}
                                                    className={"form-control text-center " + (changedValues[alert.metric.name] === undefined ? "" : (changedValues[alert.metric.name]['evaluation'] === undefined ? "" : " border-warning"))}
                                                    name="evaluation"
                                                    id="autoSizingInputGroup"
                                                    onChange={event => handleFormChange(index, event)}
                                                >
                                                  {EvaluationFrequencyValues.map((item, key) => (<option key={key} value={item}>{item}</option>))}
                                                </select>
                                              </Col>
                                              <Col md="1" className="d-flex align-items-center justify-content-center">
                                                {
                                                  alert.enabled ?
                                                        (
                                                          <>
                                                            <div
                                                                id="TooltipTop"
                                                                onMouseOver={() => settop(true)}
                                                                onMouseLeave={() => settop(false)}
                                                                className="alert-icon"
                                                            ><Switch
                                                                uncheckedIcon={<OffSymbol />}
                                                                checkedIcon={<OnSymbol />}
                                                                className="me-2 mb-sm-8"
                                                                height={20}
                                                                width={44}
                                                                onColor="#34c38f"
                                                                offColor="#f46a6a"
                                                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                                activeBoxShadow="0px 0px 1px 5px"
                                                                onChange={() => toggleAlert(index, alert.id)}
                                                                checked={toggles[alert.id] || false}
                                                            /></div>
                                                            <Tooltip
                                                                placement="top"
                                                                isOpen={ttop}
                                                                target="TooltipTop"
                                                                toggle={() => { settop(!ttop); }}
                                                                style={{
                                                                  border: "2px solid #f1b44c",
                                                                  borderRadius: "10px",
                                                                  backgroundColor: "#2a3042",
                                                                  zIndex: 1
                                                                }}
                                                            >
                                                              Enable/Disable the alert
                                                            </Tooltip>
                                                          </>
                                                      ) :
                                                      (
                                                          <>
                                                            <div
                                                                id="DisabledTooltipTop"
                                                                onMouseOver={() => setdtop(true)}
                                                                onMouseLeave={() => setdtop(false)}
                                                                className="alert-icon"
                                                            ><Switch
                                                                uncheckedIcon={<OffSymbol />}
                                                                className="me-1 mb-sm-8"
                                                                offColor="#f46a6a"
                                                                onColor="#34c38f"
                                                                height={20}
                                                                width={44}
                                                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                                activeBoxShadow="0px 0px 1px 5px"
                                                                onChange={() => toggleAlert(index, alert.id)}
                                                                checked={false}
                                                            /></div>
                                                            <Tooltip
                                                                placement="top"
                                                                isOpen={dttop}
                                                                target="DisabledTooltipTop"
                                                                toggle={() => { setdtop(!dttop); }}
                                                                style={{
                                                                  border: "2px solid #f1b44c",
                                                                  borderRadius: "10px",
                                                                  backgroundColor: "#2a3042",
                                                                  zIndex: 1
                                                                }}
                                                            >
                                                              Enable/Disable the alert
                                                            </Tooltip>
                                                          </>
                                                      )
                                                }
                                              </Col>
                                            </Row>
                                          </CardBody>
                                        </div>
                                    )
                                  }))
                              : alerts?.length === 0 ? (
                                  <Row className="justify-content-center align-items-center" style={{ textAlign: 'center' }}>
                                    <Col md="6">
                                      <h5>No alerts are deployed</h5>
                                    </Col>
                                  </Row>
                              ) : null}
                        </AccordionBody>
                      </AccordionItem>
                    </Fragment>
                    <Loader
                        isOpen={isLoading_DisableAlert}
                        lottieJson={deployAlertsLottie}
                        messageHeader="Disabling Alert"
                        message="The alert is not deleted. You can enable it any time again."
                    />
                    <Loader
                        isOpen={isLoading_EnableAlert}
                        lottieJson={deployAlertsLottie}
                        messageHeader="Enabling Alert"
                        message="That was easy! Hang tight while we enable your alert again."
                    />
                    <Fragment>
                      <AccordionItem>
                        <AccordionHeader targetId={"2"}>
                          <Row className="full-width">
                            <Col lg="6">
                              <h5 className="change-table-text">Alerts Missing</h5>
                            </Col>
                          </Row>
                        </AccordionHeader>
                        <AccordionBody accordionId={"2"}>
                          {finalArray?.length === 0 ? (
                              <Row className="justify-content-center align-items-center" style={{ textAlign: 'center' }}>
                                <Col md="6">
                                  <h5>Good job!!! No alerts missing</h5>
                                </Col>
                              </Row>
                          ) : finalArray?.length > 0 ? (<div className="table-responsive react-table">
                            <Table bordered hover className="table-purple">
                              <thead className="table-light table-nowrap">
                              <tr>
                                {headers.map((header, index) => (
                                    <th key={index}>
                                      <div className="mb-1">
                                        {header}
                                      </div>
                                    </th>
                                ))}
                              </tr>
                              </thead>
                              <tbody>
                              {finalArray?.map((alert, index) => {
                                return (
                                    <Fragment key={index}>
                                      <tr>
                                        <td>
                                          {alert?.matchingThreshold?.time_aggregation}
                                        </td>
                                        <td>
                                          <div className="d-inline-flex align-items-center">
                                            <div className="resource-name-truncate"
                                                 id={`resource_tooltip_missing_${index}_${alert.id}`}
                                                 style={{
                                                   display: 'inline-flex',
                                                   maxWidth: 'min-content',
                                                   whiteSpace: 'nowrap',
                                                   overflow: 'hidden',
                                                   textOverflow: 'ellipsis',
                                                   fontSize: '14px',
                                                 }}
                                                 onMouseEnter={() => handleMouseOverEndpoint(`${index}_${alert.id}`)}
                                                 onMouseLeave={() => handleMouseLeaveEndpoint(`${index}_${alert.id}`)}
                                            >
                                              <div style={{display: "inline-flex", alignItems: "center"}}>
                                                {alert?.matchingThreshold?.azure_metric?.name.length > 50 ? alert?.matchingThreshold?.azure_metric?.name.substring(0, 50) + '...' : alert?.matchingThreshold?.azure_metric?.name}
                                              </div>
                                              <Popover
                                                  placement="top"
                                                  isOpen={popoverOpen1[`${index}_${alert.id}`] || false}
                                                  target={`resource_tooltip_missing_${index}_${alert.id}`}
                                              >
                                                <PopoverBody>{alert?.matchingThreshold?.azure_metric?.name}</PopoverBody>
                                              </Popover>
                                            </div>
                                            <div
                                                className="d-inline-flex px-1"
                                                style={{paddingTop: "18px"}}
                                            >
                                              <p id={`TooltipExample_missing_${index}_${index}`}
                                                 onMouseOver={() => handleMouseOver(`missing_${index}_${index}`)}
                                                 onMouseLeave={() => handleMouseOut()}>
                                                <i className="bx bx-info-circle font-size-18"
                                                ></i>
                                              </p>
                                              <Tooltip
                                                  placement="top"
                                                  isOpen={tooltipOpen && newCurrentIndex.current === `missing_${index}_${index}`}
                                                  target={`TooltipExample_missing_${index}_${index}`}
                                                  toggle={() => toggle(`missing_${index}_${index}`)}
                                                  style={{
                                                    border: "2px solid #f1b44c",
                                                    borderRadius: "10px",
                                                    backgroundColor: "#2a3042",
                                                    zIndex: 1
                                                  }}
                                              >
                                                {alert?.matchingThreshold?.azure_metric?.description}
                                              </Tooltip>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <input
                                              type="text"
                                              id="autoSizingInputGroup"
                                              name="comparison"
                                              className="form-control text-center"
                                              value={ThresholdConditionDisplay[alert?.matchingThreshold?.operator] || alert?.matchingThreshold?.operator}
                                              placeholder="Comparison"
                                              style={{ width: '65px', height: '34px' }}
                                              readOnly
                                          />
                                        </td>
                                        <td>
                                          <div className="d-flex justify-content-center">
                                            <input
                                              type="float"
                                              value={alert?.matchingThreshold?.threshold_value}
                                              name="threshold_value"
                                              className="form-control text-center"
                                              id="autoSizingInputGroup"
                                              placeholder="Threshold Value"
                                              style={{ width: '65px', height: '34px' }}
                                              readOnly
                                            />
                                          </div>
                                        </td>
                                        <td>
                                          <div className="text-center">
                                            {alert?.matchingThreshold?.azure_metric?.unit}
                                          </div>
                                        </td>
                                        <td>
                                          <div className="d-flex justify-content-center">
                                            <input
                                              type="text"
                                              value={minutesConversion(alert?.matchingThreshold?.window_size)}
                                              name="window_size"
                                              className="form-control text-center"
                                              id="autoSizingInputGroup"
                                              placeholder="Duration"
                                              style={{ width: '90px', height: '34px' }}
                                              readOnly
                                            />
                                          </div>
                                        </td>
                                        <td>
                                          <div className="d-flex justify-content-center">
                                            <input
                                              type="text"
                                              value={minutesConversion(alert?.matchingThreshold?.evaluation_frequency)}
                                              name="evaluation_frequency"
                                              className="form-control text-center"
                                              id="autoSizingInputGroup"
                                              placeholder="Duration"
                                              style={{ width: '90px', height: '34px' }}
                                              readOnly
                                            />
                                          </div>
                                        </td>
                                        <td style={{display:"table-cell", justifyContent:'center', alignItems: 'center'}}>
                                          <div className="d-inline-flex">
                                            <button
                                              type='button'
                                              className="btn btn-primary w-md"
                                              onClick={() => {
                                                handleDeployIndividualAlert(params.resourceId, alert?.matchingThreshold?.azure_metric_id);
                                                startLoading2();
                                              }}
                                              disabled={periodError !== '' || !finalServices?.name}
                                          >
                                              Deploy Alert
                                            </button>
                                            {(!finalServices?.name) && (
                                                <>
                                                <span
                                                    id={`TooltipStatic-${index}`}
                                                    onMouseOver={() => showTooltipStatic(alert?.matchingThreshold?.azure_metric_id)}
                                                    onMouseLeave={() => hideTooltipStatic(alert?.matchingThreshold?.azure_metric_id)}
                                                    className="alert-icon py-1"
                                                >
                                                  <i className="mdi mdi-information-outline text-warning"/>
                                                </span>
                                                  <Tooltip
                                                      placement="top"
                                                      isOpen={tooltipstatic[alert?.matchingThreshold?.azure_metric_id]}
                                                      target={`TooltipStatic-${index}`}
                                                      style={{
                                                        border: "2px solid #f1b44c",
                                                        borderRadius: "10px",
                                                        backgroundColor: "#2a3042",
                                                        zIndex: 1,
                                                      }}
                                                  >
                                                    Map resource to enable deployment
                                                  </Tooltip>
                                                </>
                                            )}
                                          </div>
                                        </td>
                                      </tr>
                                    </Fragment>
                                );
                              })}
                              </tbody>
                            </Table>
                          </div>) : null
                          }
                        </AccordionBody>
                      </AccordionItem>
                    </Fragment>
                  </UncontrolledAccordion>
                </Col>
              </Row>
            </div>
          </TabPane>

          <TabPane tabId="2">
            <div>
              <Row className="custom-resource-header">
                <Col lg={12}>
                  <UncontrolledAccordion key={accordionKey} defaultOpen={defaultOpen} className="custom-accordion">
                    <Fragment>
                      <AccordionItem style={{borderBottom: "groove"}}>
                        <AccordionHeader targetId={"1"}>
                          <Row className="full-width">
                            <Col lg="6">
                              <h5 className="change-table-text">Alerts Deployed</h5>
                            </Col>
                          </Row>
                        </AccordionHeader>
                        <AccordionBody accordionId={"1"}>
                          <Row className="custom-resource-header">
                            <Col md="1">
                              <div className="mb-2">
                                Aggregation
                              </div>
                            </Col>
                            <Col md="2">
                              <div className="mb-2">
                                Metric Name
                              </div>
                            </Col>
                            <Col md="2">
                              <div className="mb-2">
                                Operator
                              </div>
                            </Col>
                            <Col md="1">
                              <div className="mb-2">
                                Alert Sensitivity
                              </div>
                            </Col>
                            <Col md="1">
                              <div className="mb-2">
                                Unit
                              </div>
                            </Col>
                            <Col md="2">
                              <div className="mb-2">
                                Min failing Periods To Alert
                                {valueError && (
                                    <p className="invalid-error">{valueError}</p>
                                )}
                              </div>
                            </Col>
                            <Col md="2">
                              <div className="mb-2">
                                No of Evaluation Periods
                                {valueError && (
                                    <p className="invalid-error">{valueError}</p>
                                )}
                              </div>
                            </Col>
                            <Col md="1">
                              <div className="mb-2">
                                Actions
                              </div>
                            </Col>
                          </Row>
                          {dynamic_alerts?.length > 0 ? (
                                  dynamic_alerts?.map((dynamic_alert, index) => {
                                    return (
                                        <div className="header" key={index}>
                                          <CardBody>
                                            <Row>
                                              <Col md="1" className="padding-t-10 mt-2">
                                                {dynamic_alert.time_aggregation}
                                              </Col>
                                              <Col md="2" className="d-inline-flex mb-1">
                                                {dynamic_alert.metric.name}
                                                <div className="resource-name-truncate"
                                                     id={`resource_tooltip_${alert?.id}`}
                                                     style={{
                                                       display: 'inline-flex',
                                                       maxWidth: 'min-content',
                                                       whiteSpace: 'nowrap',
                                                       overflow: 'hidden',
                                                       textOverflow: 'ellipsis',
                                                       fontSize: '14px',
                                                       paddingTop: "5px",
                                                     }}
                                                     onMouseEnter={() => handleMouseOverEndpoint(alert.id)}
                                                     onMouseLeave={() => handleMouseLeaveEndpoint(alert.id)}
                                                >
                                                  <div style={{display: "inline-flex", alignItems: "center"}}>
                                                    {dynamic_alert.metric.name.length > 40 ? dynamic_alert.metric.name.substring(0, 40) + '...' : dynamic_alert.metric.name}
                                                  </div>
                                                  <Popover
                                                      placement="top"
                                                      isOpen={popoverOpen1[alert.id] || false}
                                                      target={`resource_tooltip_${alert?.id}`}
                                                  >
                                                    <PopoverBody>{dynamic_alert.metric.name}</PopoverBody>
                                                  </Popover>
                                                </div>
                                                <div className="flex-column align-content-end">
                                                  <div className="d-inline-flex px-1 pt-3">
                                                    <p id={`TooltipExample_${index}`}
                                                       className="d-flex align-items-end"
                                                       onMouseOver={() => handleMouseOver(index)}
                                                       onMouseLeave={() => handleMouseOut()}>
                                                      <i className="bx bx-info-circle font-size-18 px-2"/>
                                                    </p>
                                                    <Tooltip
                                                        placement="top"
                                                        isOpen={tooltipOpen && newCurrentIndex.current === index}
                                                        target={`TooltipExample_${index}`}
                                                        toggle={() => toggle(index)}
                                                        style={{
                                                          border: "2px solid #f1b44c",
                                                          borderRadius: "10px",
                                                          backgroundColor: "#2a3042",
                                                          zIndex: 1
                                                        }}
                                                    >
                                                      {dynamic_alert.metric.description}
                                                    </Tooltip>
                                                  </div>
                                                </div>
                                              </Col>
                                              <Col md="2" className="padding-t-10">
                                                <select
                                                    id="formrow-InputState"
                                                    name="operator"
                                                    className={"form-control " + (changedValuesDynamic[dynamic_alert.metric.name] === undefined ? "" : (changedValuesDynamic[dynamic_alert.metric.name]['operator'] === undefined ? "" : " border-warning"))}
                                                    value={dynamic_alert.operator}
                                                    onChange={event => handleFormChangeDynamic(index, event)}
                                                >
                                                  {DynamicThresholdCondition.map((item, key) => (<option key={key} value={item}>{item}</option>))}
                                                </select>
                                              </Col>
                                              <Col md="1" className="padding-t-10">
                                                <select
                                                    value={dynamic_alert.alert_sensitivity}
                                                    name="alert_sensitivity"
                                                    className={"form-control " + (changedValuesDynamic[dynamic_alert.metric.name] === undefined ? "" : (changedValuesDynamic[dynamic_alert.metric.name]['alert_sensitivity'] === undefined ? "" : " border-warning"))}
                                                    id="autoSizingInputGroup"
                                                    onChange={event => handleFormChangeDynamic(index, event)}
                                                >
                                                  {AlertSensivity.map((item, key) => (<option key={key} value={item}>{item}</option>))}
                                                </select>
                                              </Col>
                                              <Col md="1" className="padding-t-10 mt-2">
                                                {dynamic_alert.metric.unit}
                                              </Col>
                                              <Col md="2" className="padding-t-10">
                                                <select
                                                    value={dynamic_alert.min_failing_periods_to_alert}
                                                    className={"form-control " + (changedValuesDynamic[dynamic_alert.metric.name] === undefined ? "" : (changedValuesDynamic[dynamic_alert.metric.name]['min_failing_periods_to_alert'] === undefined ? "" : " border-warning"))}
                                                    name="min_failing_periods_to_alert"
                                                    id="autoSizingInputGroup"
                                                    onChange={event => handleFormChangeDynamic(index, event)}
                                                >
                                                  {MinFailingPeriodsToAlert.map((item, key) => (<option key={key} value={item}>{item}</option>))}
                                                </select>
                                              </Col>
                                              <Col md="2" className="padding-t-10">
                                                <select
                                                    value={dynamic_alert.number_of_evaluation_periods}
                                                    className={"form-control " + (changedValuesDynamic[dynamic_alert.metric.name] === undefined ? "" : (changedValuesDynamic[dynamic_alert.metric.name]['number_of_evaluation_periods'] === undefined ? "" : " border-warning"))}
                                                    name="number_of_evaluation_periods"
                                                    id="autoSizingInputGroup"
                                                    onChange={event => handleFormChangeDynamic(index, event)}
                                                >
                                                  {NumberOfEvaluationPeriods.map((item, key) => (<option key={key} value={item}>{item}</option>))}
                                                </select>
                                              </Col>
                                              <Col md="1" className="padding-t-10">
                                                {
                                                  dynamic_alert.enabled ?
                                                      (
                                                          <>
                                                            <div
                                                                id="TooltipTop"
                                                                onMouseOver={() => settop(true)}
                                                                onMouseLeave={() => settop(false)}
                                                                className="alert-icon"
                                                            ><Switch
                                                                uncheckedIcon={<OffSymbol />}
                                                                checkedIcon={<OnSymbol />}
                                                                className="me-1 mb-sm-8 mb-2"
                                                                height={20}
                                                                width={44}
                                                                onColor="#34c38f"
                                                                offColor="#f46a6a"
                                                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                                activeBoxShadow="0px 0px 1px 5px"
                                                                onChange={() => toggleAlertDynamic(index, dynamic_alert.id)}
                                                                checked={dynamictoggles[dynamic_alert.id] || false}
                                                            /></div>
                                                            <Tooltip
                                                                placement="top"
                                                                isOpen={ttop}
                                                                target="TooltipTop"
                                                                toggle={() => { settop(!ttop); }}
                                                                style={{
                                                                  border: "2px solid #f1b44c",
                                                                  borderRadius: "10px",
                                                                  backgroundColor: "#2a3042",
                                                                  zIndex: 1
                                                                }}
                                                            >
                                                              Enable/Disable the alert
                                                            </Tooltip>
                                                          </>
                                                      ) :
                                                      (
                                                          <>
                                                            <div
                                                                id="DisabledTooltipTop"
                                                                onMouseOver={() => setdtop(true)}
                                                                onMouseLeave={() => setdtop(false)}
                                                                className="alert-icon"
                                                            ><Switch
                                                                uncheckedIcon={<OffSymbol />}
                                                                className="me-1 mb-sm-8 mb-2"
                                                                offColor="#f46a6a"
                                                                onColor="#34c38f"
                                                                height={20}
                                                                width={44}
                                                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                                activeBoxShadow="0px 0px 1px 5px"
                                                                onChange={() => toggleAlertDynamic(index, dynamic_alert.id)}
                                                                checked={false}
                                                            /></div>
                                                            <Tooltip
                                                                placement="top"
                                                                isOpen={dttop}
                                                                target="DisabledTooltipTop"
                                                                toggle={() => { setdtop(!dttop); }}
                                                                style={{
                                                                  border: "2px solid #f1b44c",
                                                                  borderRadius: "10px",
                                                                  backgroundColor: "#2a3042",
                                                                  zIndex: 1
                                                                }}
                                                            >
                                                              Enable/Disable the alert
                                                            </Tooltip>
                                                          </>
                                                      )
                                                }
                                              </Col>
                                            </Row>
                                          </CardBody>
                                        </div>
                                    )
                                  }))
                              : dynamic_alerts?.length === 0 ? (
                                  <Row className="justify-content-center align-items-center" style={{ textAlign: 'center' }}>
                                    <Col md="6">
                                      <h5>No alerts are deployed</h5>
                                    </Col>
                                  </Row>
                              ) : dynamic_alerts?.length === 0 && azure_missing_dynamic_alerts?.length === 0 ? (
                                  <Row className="justify-content-center align-items-center" style={{ textAlign: 'center' }}>
                                    <Col md="6">
                                      <h5>Coming Soon ..</h5>
                                    </Col>
                                  </Row>
                              ):null}
                        </AccordionBody>
                      </AccordionItem>
                    </Fragment>
                    <Loader
                        isOpen={isLoading_DisableAlert}
                        lottieJson={deployAlertsLottie}
                        messageHeader="Disabling Alert"
                        message="The alert is not deleted. You can enable it any time again."
                    />
                    <Loader
                        isOpen={isLoading_EnableAlert}
                        lottieJson={deployAlertsLottie}
                        messageHeader="Enabling Alert"
                        message="That was easy! Hang tight while we enable your alert again."
                    />
                    <Fragment>
                      <AccordionItem>
                        <AccordionHeader targetId={"2"}>
                          <Row className="full-width">
                            <Col lg="6">
                              <h5 className="change-table-text">Alerts Missing</h5>
                            </Col>
                          </Row>
                        </AccordionHeader>
                        <AccordionBody accordionId={"2"}>
                          {azure_missing_dynamic_alerts?.length === 0 ? (
                              <Row className="justify-content-center align-items-center" style={{ textAlign: 'center' }}>
                                <Col md="6">
                                  <h5>Good job!!! No alerts missing</h5>
                                </Col>
                              </Row>
                          ) : azure_missing_dynamic_alerts?.length > 0 ? (<div className="table-responsive react-table">
                            <Table bordered hover className="table-purple">
                              <thead className="table-light table-nowrap">
                              <tr>
                                {DynamicHeaders.map((header, index) => (
                                    <th key={index}>
                                      <div className="mb-2">
                                        {header}
                                      </div>
                                    </th>
                                ))}
                              </tr>
                              </thead>
                              <tbody>
                              {azure_missing_dynamic_alerts?.map((alert, index) => {
                                return (
                                    <Fragment key={index}>
                                      <tr>
                                        <td>
                                          {alert?.time_aggregation}
                                        </td>
                                        <td>
                                          <div className="d-inline-flex align-items-center">
                                            <div className="resource-name-truncate"
                                                 id={`resource_tooltip_${index}_${alert.id}`}
                                                 style={{
                                                   display: 'inline-flex',
                                                   maxWidth: 'min-content',
                                                   whiteSpace: 'nowrap',
                                                   overflow: 'hidden',
                                                   textOverflow: 'ellipsis',
                                                   fontSize: '14px',
                                                 }}
                                                 onMouseEnter={() => handleMouseOverEndpoint(`${index}_${alert.id}`)}
                                                 onMouseLeave={() => handleMouseLeaveEndpoint(`${index}_${alert.id}`)}
                                            >
                                              <div style={{display: "inline-flex", alignItems: "center"}}>
                                                {alert?.azure_metric?.name.length > 40 ? alert?.azure_metric?.name.substring(0, 40) + '...' : alert?.azure_metric?.name}
                                              </div>
                                              <Popover
                                                  placement="top"
                                                  isOpen={popoverOpen1[`${index}_${alert.id}`] || false}
                                                  target={`resource_tooltip_${index}_${alert.id}`}
                                              >
                                                <PopoverBody>{alert?.azure_metric?.name}</PopoverBody>
                                              </Popover>
                                            </div>
                                            <div
                                                className="d-inline-flex px-2"
                                                style={{paddingTop: "18px"}}
                                            >
                                              <p id={`TooltipExample_dynamic_${index}_${index}`}
                                                 onMouseOver={() => handleMouseOver(`dynamic_${index}_${index}`)}
                                                 onMouseLeave={() => handleMouseOut()}>
                                                <i className="bx bx-info-circle font-size-18"
                                                ></i>
                                              </p>
                                              <Tooltip
                                                  placement="top"
                                                  isOpen={tooltipOpen && newCurrentIndex.current === `dynamic_${index}_${index}`}
                                                  target={`TooltipExample_dynamic_${index}_${index}`}
                                                  toggle={() => toggle(`dynamic_${index}_${index}`)}
                                                  style={{
                                                    border: "2px solid #f1b44c",
                                                    borderRadius: "10px",
                                                    backgroundColor: "#2a3042",
                                                    zIndex: 1
                                                  }}
                                              >
                                                {alert?.azure_metric?.description}
                                              </Tooltip>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <input
                                              type="text"
                                              id="autoSizingInputGroup"
                                              name="comparison"
                                              className="form-control"
                                              value={alert?.operator}
                                              placeholder="Comparison"
                                              readOnly
                                          >
                                          </input>
                                        </td>
                                        <td>
                                          <input
                                              type="float"
                                              value={alert?.alert_sensitivity}
                                              name="alert_sensitivity"
                                              className="form-control"
                                              id="autoSizingInputGroup"
                                              placeholder="Threshold Value"
                                              readOnly
                                          />
                                        </td>
                                        <td>
                                          {alert?.azure_metric?.unit}
                                        </td>
                                        <td>
                                          <input
                                              type="text"
                                              value={alert?.min_failing_periods_to_alert}
                                              name="min_failing_periods_to_alert"
                                              className="form-control"
                                              id="autoSizingInputGroup"
                                              readOnly
                                          />
                                        </td>
                                        <td>
                                          <input
                                              type="text"
                                              value={alert?.number_of_evaluation_periods}
                                              name="number_of_evaluation_periods"
                                              className="form-control"
                                              id="autoSizingInputGroup"
                                              readOnly
                                          />
                                        </td>
                                        <td style={{display: 'flex', alignItems: 'center'}}>
                                          <button
                                              type='button'
                                              className="btn btn-primary w-md"
                                              onClick={() => {
                                                handleDeployIndividualDynamicAlert(params.resourceId, alert?.id);
                                                startLoading2();
                                              }}
                                              disabled={periodError !== '' || !finalServices?.name}
                                          >
                                            Deploy Alert
                                          </button>
                                          {!finalServices?.name && (
                                              <>
                                                <span
                                                    id={`tooltipDynamic-${alert?.id}`}
                                                    onMouseOver={() => showTooltipDynamic(alert?.id)}
                                                    onMouseLeave={() => hideTooltipDynamic(alert?.id)}
                                                    className="alert-icon"
                                                >
                                                  <i className="mdi mdi-information-outline text-warning" />
                                                </span>
                                                <Tooltip
                                                    placement="top"
                                                    isOpen={tooltipdynamic[alert?.id]}
                                                    target={`tooltipDynamic-${alert?.id}`}
                                                    style={{
                                                      border: "2px solid #f1b44c",
                                                      borderRadius: "10px",
                                                      backgroundColor: "#2a3042",
                                                      zIndex: 1,
                                                    }}
                                                >
                                                  Map resource to enable deployment
                                                </Tooltip>
                                              </>
                                          )}
                                        </td>
                                      </tr>
                                    </Fragment>
                                );
                              })}
                              </tbody>
                            </Table>
                          </div>) :  dynamic_alerts?.length === 0 && azure_missing_dynamic_alerts?.length === 0 ? (
                              <Row className="justify-content-center align-items-center" style={{ textAlign: 'center' }}>
                                <Col md="6">
                                  <h5>Coming Soon ..</h5>
                                </Col>
                              </Row>
                          ):null
                          }
                        </AccordionBody>
                      </AccordionItem>
                    </Fragment>
                  </UncontrolledAccordion>
                </Col>
              </Row>
            </div>
          </TabPane>
        </TabContent>
      </div>

      <Modal isOpen={mapServiceModal} role="dialog" autoFocus={true} keyboard={false} centered backdrop="static"
             data-toggle="modal">
        <div className="d-flex justify-content-center">
          <ModalHeader className="border-bottom-2">
            <span className="modal-header-resource">Map Resources to Application Service</span>
          </ModalHeader>
        </div>
        <div className="modal-body">
          <Row className="full-width">
            <Col lg="12" className="">
              {
                (() => {
                  if (primaryChannel?.name === 'Email') {
                    return (
                      <h5 className="text-primary select-service mb-3">Select Application Service</h5>
                    )
                  } else if (primaryChannel?.name === 'PagerDuty') {
                    return (
                      <h5 className="text-primary select-service mb-3">Select PagerDuty Service</h5>
                    )
                  } else if (primaryChannel?.name === 'OpsGenie') {
                    return (
                      <h5 className="text-primary select-service mb-3">Select OpsGenie Team</h5>
                    )
                  }
                })()
              }
              <div className="text-center mb-4">
                <div className="row justify-content-center">
                  <div className="col-xl-10">
                    <div className="mb-2">
                      <Select
                        isClearable
                        value={serviceOptions.find(option => option.label === selectedService)}
                        options={[
                          ...serviceOptions, 
                          { value: "/add-service", label: "Add new service" } 
                        ]}
                        placeholder={
                          primaryChannel?.name === 'Email' ? 'Select an Application Service' :
                            primaryChannel?.name === 'PagerDuty' ? 'Select a PagerDuty Service' :
                              primaryChannel?.name === 'OpsGenie' ? 'Select an OpsGenie Team' :
                                'Select a Service'
                        }
                        onChange={(selectedOption) => {
                          if (selectedOption && selectedOption.value === "/add-service") {
                            window.location.href = "/add-service";
                          } else {
                            handleServiceFormChange(selectedOption); 
                          }
                        }}
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 0,
                          colors: {
                            ...theme.colors,
                            neutral0: '#222736',
                            neutral5: '#485EC4',
                            neutral10: '#485EC4',
                            neutral60: '#ffffff',
                            neutral70: '#ffffff',
                            neutral80: '#ffffff',
                            neutral90: '#ffffff',
                            primary: '#485EC4',
                          },
                        })}
                        styles={customStyles}
                        getOptionLabel={(option) => customOptionRenderer(option)}
                      />
                    </div>
                    <div className="mb-2">
                      <Select
                        isClearable
                        value={environments.find(env => env.value === selectedEnvironment)}
                        options={environments}
                        placeholder={
                          primaryChannel?.name === 'Email' ? 'Select an Application Service' :
                            primaryChannel?.name === 'PagerDuty' ? 'Select a PagerDuty Service' :
                              primaryChannel?.name === 'OpsGenie' ? 'Select an OpsGenie Team' :
                                'Select a Service'
                        }
                        onChange={event => handleEnvironmentChange(event)}
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 0,
                          colors: {
                            ...theme.colors,
                            neutral0: '#222736',
                            neutral5: '#485EC4',
                            neutral10: '#485EC4',
                            neutral60: '#ffffff',
                            neutral70: '#ffffff',
                            neutral80: '#ffffff',
                            neutral90: '#ffffff',
                            primary: '#485EC4',
                          },
                        })}
                        styles={customStyles}
                      />
                    </div>
                    <Row className="full-width mt-4 pt-4">
                      <Col lg="6" className="mt-4">
                        <Link onClick={cancelMapServiceModal} className="btn btn-secondary w-md">Cancel</Link>
                      </Col>
                      <Col lg="6" className="mt-4">
                        <Link onClick={() => {
                          startLoading1();
                          handleServiceMapping();
                        }} className="btn btn-primary w-md">Map {primaryChannel?.name === 'OpsGenie' ? 'Team' : 'Service'}</Link>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Modal>

      <Modal isOpen={azureDeployModal} role="dialog" autoFocus={true} keyboard={false} centered backdrop="static" data-toggle="modal">
        <div>
          <ModalHeader className="border-bottom-2">
            <span className="modal-header-resource">Deploy Default Alerts</span>
          </ModalHeader>
        </div>
        <div className="modal-body">
          <Row className="full-width">
            <Col lg="12" className="mt-4">
              <div className="text-center mb-4">
                <div className="row justify-content-center">
                  <div className="col-xl-10">
                    <h4 className="text-primary">Are you sure you want to deploy these alerts?</h4>
                    <h6 className="mt-4">
                      This will deploy ALL the default alerts for the selected resources. Please review the{' '}
                      <Link to='/azure-thresholds' target="_blank">
                        default thresholds
                      </Link>{' '}
                      and modify, if required.
                    </h6>
                    <Row className="full-width">
                      <Col lg="6" className="mt-4">
                        <Link onClick={cancelDeployModal} className="btn btn-secondary w-md">
                          Cancel
                        </Link>
                      </Col>
                      <Col lg="6" className="mt-4">
                        <Link className="btn btn-primary w-md" onClick={() => {
                          startLoading2();
                          handleDeploy();
                        }}>
                          Deploy
                        </Link>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Modal>

      <Modal
        isOpen={deployModal}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        size="xl"
        tabIndex="-1"
      >
        <div className="modal-header border-bottom-1 text-center">
          <h4 className="text-primary">Changing thresholds for the alert!</h4>
          <button type="button" className="btn-close"
            onClick={() => {
              setDeployModal(!deployModal);
            }}
            aria-label="Close"
          >
          </button>
        </div>
        <div className="modal-body">
          <div className="text-center mb-4">
            <div className="row justify-content-center">
              <div className="col-xl-10">
                <p className="font-size-14 mb-4">
                  Note: This does not affect your default thresholds. Only this alert will be modified.
                </p>
                <div className="table-responsive react-table">
                  <Table bordered hover className="table-purple">
                    <thead className="table-light table-nowrap">
                      <tr>
                        <th>Alert Name</th>
                        {changeHeaders.map((header, index) => (
                          <th key={index}>
                            {header}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    {
                      Object.entries({ ...changedValues, ...changedValuesDynamic }).map(([parent_key, changedValue], index) => {
                        return (
                          <Fragment key={index}>
                            <tbody>
                              {
                                Object.entries(changedValue).map(([key, value], index2) => {
                                  return (
                                    <Fragment key={index2}>
                                      <tr>
                                        <td>
                                          {parent_key}
                                        </td>
                                        <td>
                                          {value.name}
                                        </td>
                                        <td>
                                          {(key === "window_size" || key === "evaluation") &&
                                          value.old
                                              ? minutesConversion(value.old)
                                              : value.old}
                                        </td>
                                        <td>
                                          <b>{value.new}</b>
                                        </td>
                                      </tr>
                                    </Fragment>
                                  )
                                })
                              }
                            </tbody>

                          </Fragment>
                        )
                      })
                    }
                  </Table>
                </div>
                <Button
                  color="primary"
                  type="button"
                  id="button-addon2"
                  onClick={() => {
                    startLoading_SaveAlert();
                    handleSubmit();
                  }}
                >
                  Deploy Alerts
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Loader
        isOpen={isLoading1}
        lottieJson={connectTeamLottie}
        messageHeader="Resource - Team Mapping"
        message="Please wait while we map the selected resources to the respective team."
      />
      <Loader
        isOpen={isLoading2}
        lottieJson={deployAlertsLottie}
        messageHeader="Deploying Alerts"
        message="That was easy! Hang tight while we deploy your alerts."
      />
      <Loader
        isOpen={isLoading_SaveAlert}
        lottieJson={savingDefaultsLottie}
        messageHeader="Saving Alert"
        message="Please wait while your alert is being updated."
      />


    </React.Fragment>
  )
}
AzureAlert.propTypes = {
  orders: PropTypes.array,
  onGetOrders: PropTypes.func,
  onGetServices: PropTypes.func,
};

export default withRouter(AzureAlert);